import type { LatLon } from '../geo';

/**
 * Feste Orte der Spielwelt.
 *
 * Alle Positionen sind real und liegen bewusst an Stellen mit eigener
 * Geschichte oder auffaelliger Bathymetrie — das Hoehenraster liefert dort
 * ohne Zusatzaufwand Charakter (Graben, Bank, Seeberg).
 */

export type PlaceKind = 'base' | 'landmark';

export interface Place {
  readonly id: string;
  readonly kind: PlaceKind;
  readonly position: LatLon;
  /** Uebersetzungsschluessel fuer den angezeigten Namen. */
  readonly nameKey: string;
}

/**
 * Die Forschungsbasis liegt an der Nordkante des Northwest Providence Channel,
 * knapp innerhalb der Miami-Bermuda-Kante des Dreiecks. Unter dem Kai stehen
 * rund 100 m Wasser: tief genug, dass das U-Boot direkt vor der Tuer auf Tiefe
 * geht, und die Fahrrinne fuehrt ohne Umweg in die offene See.
 *
 * **Sie lag frueher zehn Seemeilen weiter nordoestlich** (26,3 N / 77,5 W),
 * mitten auf der Little Bahama Bank. Das ging, solange nur das Hoehenraster
 * ueber Befahrbarkeit entschied — bei einer Bogenminute Rasterweite sah die
 * Bank dort nach offenem Wasser aus. Seit die gezeichneten Kuestenzuege in die
 * Wegsuche eingehen (M8), zeigt sich der Ort als das, was er wirklich ist: eine
 * von Cays ringsum geschlossene Lagune mit dreizehn Zellen Wasser und ohne
 * Verbindung zur See. Ein Schiff waere dort nie herausgekommen.
 */
export const HOME_BASE: Place = {
  id: 'base',
  kind: 'base',
  position: { lat: 26.17, lon: -77.6 },
  nameKey: 'place.base',
};

export const LANDMARKS: readonly Place[] = [
  {
    // Milwaukee-Tief: mit rund 8.400 m der tiefste Punkt des Atlantiks.
    id: 'trench',
    kind: 'landmark',
    position: { lat: 19.7, lon: -66.5 },
    nameKey: 'place.trench',
  },
  {
    // Tongue of the Ocean: ein über 2.000 m tiefer Graben mitten in der
    // flachen Bahama-Bank. Bewusst das noerdliche Ende — weiter suedlich
    // verlaesst der Graben das Dreieck.
    id: 'tongue',
    kind: 'landmark',
    position: { lat: 24.9, lon: -77.7 },
    nameKey: 'place.tongue',
  },
  {
    // Offene Sargassosee — hier gibt es nichts als Wasser und Tiefe.
    id: 'sargasso',
    kind: 'landmark',
    position: { lat: 28.0, lon: -68.5 },
    nameKey: 'place.sargasso',
  },
  {
    // Der Bermuda-Seeberg steigt aus über 4.000 m Tiefe fast bis zur Oberfläche.
    id: 'seamount',
    kind: 'landmark',
    position: { lat: 32.1, lon: -64.9 },
    nameKey: 'place.seamount',
  },
];

export const ALL_PLACES: readonly Place[] = [HOME_BASE, ...LANDMARKS];
